/**
 * Copyright(c) Live2D Inc. All rights reserved.
 *
 * Use of this source code is governed by the Live2D Open Software license
 * that can be found at https://www.live2d.com/eula/live2d-open-software-license-agreement_en.html.
 */
import { LogLevel } from '../lib/live2d/live2dcubismframework';
export const CanvasSize = 'auto';
export const CanvasNum = 1;
export const ViewScale = 1.0;
export const ViewMaxScale = 2.0;
export const ViewMinScale = 0.8;
export const ViewLogicalLeft = -1.0;
export const ViewLogicalRight = 1.0;
export const ViewLogicalBottom = -1.0;
export const ViewLogicalTop = 1.0;
export const ViewLogicalMaxLeft = -2.0;
export const ViewLogicalMaxRight = 2.0;
export const ViewLogicalMaxBottom = -2.0;
export const ViewLogicalMaxTop = 2.0;
export const ResourcesPath = '/models/';
export const BackImageName = '';
export const GearImageName = '';
export const PowerImageName = '';
export const ModelDefinitions = [
    {
        directory: 'Epsilon_free/runtime',
        file: 'Epsilon_free.model3.json'
    }
];
export const ModelDirSize = ModelDefinitions.length;
export const MotionGroupIdle = 'Idle';
export const MotionGroupTapBody = 'Tap';
export const HitAreaNameHead = 'Head';
export const HitAreaNameBody = 'Body';
export const PriorityNone = 0;
export const PriorityIdle = 1;
export const PriorityNormal = 2;
export const PriorityForce = 3;
export const MOCConsistencyValidationEnable = true;
export const MotionConsistencyValidationEnable = true;
export const DebugLogEnable = true;
export const DebugTouchLogEnable = false;
export const CubismLoggingLevel = LogLevel.LogLevel_Verbose;
export const RenderTargetWidth = 1900;
export const RenderTargetHeight = 1000;
